import { gql } from "lib/apolloClient";
import { staffFragment, studentFragment } from "modules/CommonFragments";

export const aiFragment = {
  aiMessage: gql`
    fragment aiMessageItem on AiMessage {
      id
      role
      authorType
      content
      metadata
      createdBy {
        ...staffItem
        ...studentItem
      }
      votes {
        myVote
      }
      usageMetricsId
      parentMessage {
        id
      }
      attachments {
        id
        name
        type
        mimeType
        url
        thumbUrl
        signedUrl
        title
        metadata
        streamUrl
        parentType
        createdBy {
          id
          type
        }
        toddleDoc {
          id
          value
        }
        createdAt
      }
    }
    ${staffFragment.basicStaffDetails}
    ${studentFragment.basicStudentDetails}
  `,
};
